import React from "react";

import WidgetContainer from "components/WidgetContainer/WidgetContainer";
import AbsButton from "components/Button/AbsButton";

import YtPlayer from "components/YtPlayer/YtPlayer";
import EpisodeTwoImage from "images/security-page/episode-1.png";
import TXSafeDesktop from "images/security-page/3xsafe-desktop.png";
import TXSafeMobile from "images/security-page/3xsafe-mobile.png";
import OvalElement from "images/security-page/safetyguide-oval.svg";
import TabElement from "images/security-page/safetyguide-tab.svg";
import ExternalIconEl from "images/security-page/external-icon.svg";

import "./SafetyGuideWidget.css";

const SafetyGuideWidget = () => {
    return (
        <>
            <WidgetContainer stylesClass="safety-guide">
                <img
                    src={TabElement}
                    className="sg-top"
                    alt=""
                    draggable="false"
                />
                <img
                    src={TabElement}
                    className="sg-bottom"
                    alt=""
                    draggable="false"
                />

                <div className="safety-guide__header">
                    <div>
                        <h2>Your guide to safe transactions</h2>
                        <p>
                            Learn to identify and report suspicious payment
                            requests, transactions and profiles with these
                            safety tips.
                        </p>
                    </div>
                    <AbsButton
                        pagePath="https://blog.phonepe.com/tagged/phishing"
                        btnText="Know More"
                        btnStyle="btnStyle"
                        btnArrowFlag={false}
                    />
                </div>
                <div className="safety-guide-widget">
                    <div className="safety-guide-widget__video-container">
                        <YtPlayer id="AYLC-VGdgwg" />
                    </div>

                    <div className="safety-guide-widget__content">
                        <div className="ep2">
                            <img
                                src={OvalElement}
                                className="sgwc-oval"
                                alt=""
                                draggable="false"
                            />

                            <img
                                src={EpisodeTwoImage}
                                alt=""
                                className="ep2-thumbnail"
                                draggable="false"
                            />
                            <a
                                href="https://www.youtube.com/watch?v=VpS_tx8L8XY&list=PL4dV2TSluEZy8T_rq1gy9xu1Bl8njGcvp"
                                target="_blank"
                                rel="noreferrer"
                                className="ep2-overlay"
                            >
                                <img
                                    src={ExternalIconEl}
                                    alt=""
                                    draggable="false"
                                />
                            </a>
                        </div>
                        <img
                            src={TXSafeDesktop}
                            alt=""
                            className="tx-desktop"
                            draggable="false"
                        />
                        <img
                            src={TXSafeMobile}
                            alt=""
                            className="tx-mobile"
                            draggable="false"
                        />
                    </div>
                </div>
            </WidgetContainer>
        </>
    );
};
export default SafetyGuideWidget;
